import { Popover, PopoverContent, PopoverTrigger } from '@predoc/cow';
import { hasExtractedValue } from './efax-cell-utils';
import { MissingValue } from './MissingValue';

interface OverflowListCellProps {
  values: string[];
}

export const OverflowListCell = ({ values }: OverflowListCellProps) => {
  const [visibleValue, ...hiddenValues] = values;

  if (!hasExtractedValue(visibleValue)) {
    return <MissingValue />;
  }

  if (hiddenValues.length === 0) {
    return (
      <span className="break-words whitespace-normal">{visibleValue}</span>
    );
  }

  return (
    <div className="flex min-w-0 items-start gap-1">
      <span className="min-w-0 break-words whitespace-normal">
        {visibleValue}
      </span>
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="text-muted-foreground shrink-0 underline-offset-4 hover:underline"
          >
            +{hiddenValues.length}
          </button>
        </PopoverTrigger>
        <PopoverContent
          className="w-64 max-w-64 overflow-x-hidden p-2"
          align="start"
        >
          <div className="min-w-0 space-y-1 text-sm">
            {values.map((value, index) => (
              <div
                key={`${value}-${index}`}
                className="rounded-sm px-2 py-1 break-all"
              >
                {value}
              </div>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
